export const SERVICE = 'FIDELIZATION'
